import { MachineEpromConfiguration } from "./models/machineConfiguration";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../records/utils";

export const vsServiceName = "gratonUtilsService";

export class GratonUtilsService {
  static $inject = [RecordsUtilsServiceName];
  constructor(private readonly recordUtilsService: RecordsUtilsService) {}

  private getDefaultEproms(): MachineEpromConfiguration[] {
    const defaultItems = [
      {
        Id: 0,
        EpromType: "Personality",
      },
      {
        Id: 0,
        EpromType: "OS",
      },
      {
        Id: 0,
        EpromType: "BOOT/BIOS",
      },
      {
        Id: 0,
        EpromType: "BV",
      },
      {
        Id: 0,
        EpromType: "Printer",
      },
    ];

    defaultItems.forEach((i) => this.recordUtilsService.assignId(i));

    return defaultItems;
  }

  isDefaultEprom(eprom: MachineEpromConfiguration): boolean {
    return !!this.getDefaultEproms().find(
      (de) => de.EpromType === eprom.EpromType
    );
  }

  normalizeEproms(
    eproms: MachineEpromConfiguration[]
  ): MachineEpromConfiguration[] {
    const defaultEproms = this.getDefaultEproms();
    return [
      ...defaultEproms.map(
        (defaultEprom) =>
          eproms?.find((e) => e.EpromType == defaultEprom.EpromType) ??
          defaultEprom
      ),
      ...(eproms?.filter(
        (e) => !defaultEproms.find((de) => de.EpromType === e.EpromType)
      ) ?? []),
    ];
  }
}
